const animals = [
  {
    "web-scraper-order": "1666017682-484",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🫧 Bubbles",
    "name-href": "https://emojipedia.org/bubbles/",
    emoji: "🫧",
    emojiName: "🫧 Bubbles",
    description:
      "A few floating bubbles. May be used to represent soap suds, carbonation, or an effervescent personality.",
  },
  {
    "web-scraper-order": "1666017685-485",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎍 Pine Decoration",
    "name-href": "https://emojipedia.org/pine-decoration/",
    emoji: "🎍",
    emojiName: "🎍 Pine Decoration",
    description:
      "A Japanese kadomatsu, composed of pine leaves and bamboo shoots. Traditionally placed outside homes in Japan around the New Year to welcome spirits for a plentiful, happy year ahead.",
  },
  {
    "web-scraper-order": "1666017687-486",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎋 Tanabata Tree",
    "name-href": "https://emojipedia.org/tanabata-tree/",
    emoji: "🎋",
    emojiName: "🎋 Tanabata Tree",
    description:
      "A Tanabata tree, a type of wish tree on which people hang wishes written on paper and other decorations during Tanabata, a Japanese festival celebrating two heavenly lovers. Depicted as one or two stalks of green bamboo, on which hangs one or more slips of paper, generally red.",
  },
  {
    "web-scraper-order": "1666017690-487",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "✨ Sparkles",
    "name-href": "https://emojipedia.org/sparkles/",
    emoji: "✨",
    emojiName: "✨ Sparkles",
    description:
      "The glittering flashes of sparkles. Generally depicted as a cluster of three, yellow four-point stars, with one large sparkle and two small ones to its left or right.",
  },
  {
    "web-scraper-order": "1666017693-488",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎄 Christmas Tree",
    "name-href": "https://emojipedia.org/christmas-tree/",
    emoji: "🎄",
    emojiName: "🎄 Christmas Tree",
    description:
      "A classic Christmas tree, an evergreen tree decorated with lights and ornaments to celebrate Christmas.  Depicted with round, variously colored ornaments and topped with a yellow star.",
  },
  {
    "web-scraper-order": "1666017697-489",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌊 Water Wave",
    "name-href": "https://emojipedia.org/water-wave/",
    emoji: "🌊",
    emojiName: "🌊 Water Wave",
    description:
      "A wave of water, as breaks at the beach. Depicted as a blue wave with a foamy, white crest, curling to the right.",
  },
  {
    "web-scraper-order": "1666017699-490",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💧 Droplet",
    "name-href": "https://emojipedia.org/droplet/",
    emoji: "💧",
    emojiName: "💧 Droplet",
    description: "A single, light blue droplet, as of water, sweat, or tears.",
  },
  {
    "web-scraper-order": "1666017703-491",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🔥 Fire",
    "name-href": "https://emojipedia.org/fire/",
    emoji: "🔥",
    emojiName: "🔥 Fire",
    description:
      "A flame, as produced when something is on fire. Depicted as a red, orange, and yellow flickering flame.",
  },
  {
    "web-scraper-order": "1666017706-492",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☄️ Comet",
    "name-href": "https://emojipedia.org/comet/",
    emoji: "☄️",
    emojiName: "☄️ Comet",
    description:
      "A comet, an icy, rocky space object that can form a tail of gas and dust when near the sun. Generally depicted as an icy-blue comet, as if streaking downwards in a night sky.",
  },
  {
    "web-scraper-order": "1666017710-493",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛄ Snowman Without Snow",
    "name-href": "https://emojipedia.org/snowman-without-snow/",
    emoji: "⛄",
    emojiName: "⛄ Snowman Without Snow",
    description:
      "A classic snowman, as Frosty the Snowman. Depicted as a snowman, facing forward, made from two or three large snowballs and stick arms, dressed with a top hat, a carrot nose, coal eyes, and two or three buttons on its torso. Sometimes shown with a smile and a red scarf.",
  },
  {
    "web-scraper-order": "1666017715-494",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☃️ Snowman",
    "name-href": "https://emojipedia.org/snowman/",
    emoji: "☃️",
    emojiName: "☃️ Snowman",
    description:
      "A classic snowman, as Frosty the Snowman, with snowflakes falling on it. Depicted as a snowman, facing forward, made from two or three large snowballs and stick arms, dressed with a top hat, a carrot nose, coal eyes, and two or three buttons on its torso. Sometimes shown with a smile and a red scarf.",
  },
  {
    "web-scraper-order": "1666017719-495",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "❄️ Snowflake",
    "name-href": "https://emojipedia.org/snowflake/",
    emoji: "❄️",
    emojiName: "❄️ Snowflake",
    description:
      "The unique, feathery ice crystal of a snowflake. Depicted as a bluish-white snowflake with six intricate symmetrical branches.",
  },
  {
    "web-scraper-order": "1666017721-496",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⚡ High Voltage",
    "name-href": "https://emojipedia.org/high-voltage/",
    emoji: "⚡",
    emojiName: "⚡ High Voltage",
    description:
      "A symbol for high voltage, as warns against injury from electricity. Depicted as a jagged yellow bolt.",
  },
  {
    "web-scraper-order": "1666017725-497",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☔ Umbrella with Rain Drops",
    "name-href": "https://emojipedia.org/umbrella-with-rain-drops/",
    emoji: "☔",
    emojiName: "☔ Umbrella with Rain Drops",
    description:
      "An umbrella, opened to provide cover from rain. Generally depicted with purple fabric and a hooked handle with several rain droplets falling on its top.",
  },
  {
    "web-scraper-order": "1666017729-498",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☂️ Umbrella",
    "name-href": "https://emojipedia.org/umbrella/",
    emoji: "☂️",
    emojiName: "☂️ Umbrella",
    description:
      "An opened, dry umbrella. Generally depicted with purple fabric and a hooked handle.",
  },
  {
    "web-scraper-order": "1666017732-499",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌈 Rainbow",
    "name-href": "https://emojipedia.org/rainbow/",
    emoji: "🌈",
    emojiName: "🌈 Rainbow",
    description:
      "The colorful arc of a rainbow, as may appear after rain. Generally depicted as the left half of a full rainbow, showing six bands of color: red, orange, yellow, green, blue, and violet.",
  },
  {
    "web-scraper-order": "1666017738-500",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌬️ Wind Face",
    "name-href": "https://emojipedia.org/wind-face/",
    emoji: "🌬️",
    emojiName: "🌬️ Wind Face",
    description:
      "A face blowing the wind, as a personification of nature (e.g., Mother Nature, the North Wind) who creates the wind by blowing air from its mouth. Depicted as a gray, profile of a human face, generally with a feminine appearance, blowing swirls from her mouth to the right.",
  },
  {
    "web-scraper-order": "1666017741-501",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌫️ Fog",
    "name-href": "https://emojipedia.org/fog/",
    emoji: "🌫️",
    emojiName: "🌫️ Fog",
    description:
      "Fog, as obscures visibility. Generally depicted as a square of a gray, hazy, cloud-like mass.",
  },
  {
    "web-scraper-order": "1666017746-502",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌪️ Tornado",
    "name-href": "https://emojipedia.org/tornado/",
    emoji: "🌪️",
    emojiName: "🌪️ Tornado",
    description:
      "A tornado, a destructive column of air. Depicted as a gray, funnel-shaped cloud, rotating in contact with the ground.",
  },
  {
    "web-scraper-order": "1666017751-503",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌩️ Cloud with Lightning",
    "name-href": "https://emojipedia.org/cloud-with-lightning/",
    emoji: "🌩️",
    emojiName: "🌩️ Cloud with Lightning",
    description:
      "A thundercloud. Depicted as a yellow lightning bolt flashing from a white cloud.",
  },
  {
    "web-scraper-order": "1666017755-504",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌨️ Cloud with Snow",
    "name-href": "https://emojipedia.org/cloud-with-snow/",
    emoji: "🌨️",
    emojiName: "🌨️ Cloud with Snow",
    description:
      "A snow cloud. Depicted as blue snowflakes falling from a white cloud.",
  },
  {
    "web-scraper-order": "1666017759-505",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌧️ Cloud with Rain",
    "name-href": "https://emojipedia.org/cloud-with-rain/",
    emoji: "🌧️",
    emojiName: "🌧️ Cloud with Rain",
    description:
      "A rain cloud. (Keep dry with ☔ Umbrella With Rain Drops.) Depicted as blue raindrops falling from a white cloud. Most platforms depict the raindrops falling to the left.",
  },
  {
    "web-scraper-order": "1666017762-506",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌦️ Sun Behind Rain Cloud",
    "name-href": "https://emojipedia.org/sun-behind-rain-cloud/",
    emoji: "🌦️",
    emojiName: "🌦️ Sun Behind Rain Cloud",
    description:
      "A yellow sun half covered by a white rain cloud with blue raindrops. Most platforms depict the raindrops falling to the left. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017767-507",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌥️ Sun Behind Large Cloud",
    "name-href": "https://emojipedia.org/sun-behind-large-cloud/",
    emoji: "🌥️",
    emojiName: "🌥️ Sun Behind Large Cloud",
    description:
      "A yellow sun mostly covered by a large, white cloud. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017771-508",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌤️ Sun Behind Small Cloud",
    "name-href": "https://emojipedia.org/sun-behind-small-cloud/",
    emoji: "🌤️",
    emojiName: "🌤️ Sun Behind Small Cloud",
    description:
      "A yellow sun partially covered by a small, white cloud. Position of the cloud varies across platforms.",
  },
  {
    "web-scraper-order": "1666017776-509",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛈️ Cloud with Lightning and Rain",
    "name-href": "https://emojipedia.org/cloud-with-lightning-and-rain/",
    emoji: "⛈️",
    emojiName: "⛈️ Cloud with Lightning and Rain",
    description:
      "Blue raindrops falling from a white cloud with a lightning bolt flashing.",
  },
  {
    "web-scraper-order": "1666017781-510",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛅ Sun Behind Cloud",
    "name-href": "https://emojipedia.org/sun-behind-cloud/",
    emoji: "⛅",
    emojiName: "⛅ Sun Behind Cloud",
    description:
      "A yellow sun half covered by a white cloud. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017785-511",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☁️ Cloud",
    "name-href": "https://emojipedia.org/cloud/",
    emoji: "☁️",
    emojiName: "☁️ Cloud",
    description:
      "A fluffy, white cloud, as a cumulus. May be used as a weather icon to represent a cloudy or overcast day.",
  },
  {
    "web-scraper-order": "1666017789-512",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌠 Shooting Star",
    "name-href": "https://emojipedia.org/shooting-star/",
    emoji: "🌠",
    emojiName: "🌠 Shooting Star",
    description:
      "A stylized representation of a shooting star, a small, fast meteor that burns up in the atmosphere. Generally depicted as a gold, five-point star trailing yellow motion lines against a night sky, as if moving down to the left.",
  },
  {
    "web-scraper-order": "1666017792-513",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌟 Glowing Star",
    "name-href": "https://emojipedia.org/glowing-star/",
    emoji: "🌟",
    emojiName: "🌟 Glowing Star",
    description:
      "A glowing, five-point gold star. Depicted as ⭐ Star with stylized bursts in between its points, representing glowing or twinkling.",
  },
  {
    "web-scraper-order": "1666017795-514",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⭐ Star",
    "name-href": "https://emojipedia.org/star/",
    emoji: "⭐",
    emojiName: "⭐ Star",
    description: "A classic, five-point gold star.",
  },
  {
    "web-scraper-order": "1666017801-515",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌞 Sun with Face",
    "name-href": "https://emojipedia.org/sun-with-face/",
    emoji: "🌞",
    emojiName: "🌞 Sun with Face",
    description:
      "A sun with a smiling face, as a Sun of May. Generally depicted as a golden-yellow disc with a smiling, often human face with a nose, radiating triangular rays, representing the sun's heat and light.",
  },
  {
    "web-scraper-order": "1666017806-516",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌝 Full Moon Face",
    "name-href": "https://emojipedia.org/full-moon-face/",
    emoji: "🌝",
    emojiName: "🌝 Full Moon Face",
    description:
      "A full moon with a smiling face, as the Man in the Moon. Generally depicts the moon as a dark disc with a slightly smiling human face and nose.",
  },
  {
    "web-scraper-order": "1666017810-517",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☀️ Sun",
    "name-href": "https://emojipedia.org/sun/",
    emoji: "☀️",
    emojiName: "☀️ Sun",
    description:
      "The sun, the star at the center of our solar system. Generally depicted as a golden-yellow disc radiating eight triangular rays, representing the sun’s heat and light.",
  },
  {
    "web-scraper-order": "1666017814-518",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌜 Last Quarter Moon Face",
    "name-href": "https://emojipedia.org/last-quarter-moon-face/",
    emoji: "🌜",
    emojiName: "🌜 Last Quarter Moon Face",
    description:
      "A last quarter moon with a human face, as the Man in the Moon. Generally depicts a wide, golden crescent moon with the profile of slightly smiling human face with a nose, facing right.",
  },
  {
    "web-scraper-order": "1666017818-519",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌛 First Quarter Moon Face",
    "name-href": "https://emojipedia.org/first-quarter-moon-face/",
    emoji: "🌛",
    emojiName: "🌛 First Quarter Moon Face",
    description:
      "A first quarter moon with a human face, as the Man in the Moon. Generally depicts a wide, golden crescent moon with the profile of a slightly smiling human face with a nose, facing left.",
  },
  {
    "web-scraper-order": "1666017823-520",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌚 New Moon Face",
    "name-href": "https://emojipedia.org/new-moon-face/",
    emoji: "🌚",
    emojiName: "🌚 New Moon Face",
    description:
      "A new moon with a smiling face, as the Man in the Moon. Generally depicts the moon as a dark disc with a slightly smiling human face and nose.",
  },
  {
    "web-scraper-order": "1666017825-521",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌙 Crescent Moon",
    "name-href": "https://emojipedia.org/crescent-moon/",
    emoji: "🌙",
    emojiName: "🌙 Crescent Moon",
    description:
      "A crescent moon, as in its waxing crescent phase. Depicts the moon as a thin, golden crescent, curving to the right and not displaying the remaining outline of the moon.",
  },
  {
    "web-scraper-order": "1666017828-522",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌘 Waning Crescent Moon",
    "name-href": "https://emojipedia.org/waning-crescent-moon/",
    emoji: "🌘",
    emojiName: "🌘 Waning Crescent Moon",
    description:
      "A waning crescent moon (appearing to become smaller), the last of the phases of the moon. Depicts the moon as a cratered disc, its left side illuminated in a thin, golden or silver crescent, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017831-523",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌗 Last Quarter Moon",
    "name-href": "https://emojipedia.org/last-quarter-moon/",
    emoji: "🌗",
    emojiName: "🌗 Last Quarter Moon",
    description:
      "A last quarter moon, the seventh of the eight phases of the moon. Depicts the moon as a cratered disc, its left side half illuminated in gold or silver, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017833-524",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌖 Waning Gibbous Moon",
    "name-href": "https://emojipedia.org/waning-gibbous-moon/",
    emoji: "🌖",
    emojiName: "🌖 Waning Gibbous Moon",
    description:
      "A waning gibbous moon (appearing more than half full but getting smaller), the sixth of the eight phases of the moon. Depicts the moon as a cratered disc, mostly illuminated in gold or silver, but with its right side a dark crescent.",
  },
  {
    "web-scraper-order": "1666017836-525",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌕 Full Moon",
    "name-href": "https://emojipedia.org/full-moon/",
    emoji: "🌕",
    emojiName: "🌕 Full Moon",
    description:
      "A full moon, the fifth phase of the eight phases of the moon, when it is completely lit. Depicts the moon as a full, gold or silver, cratered disc, completely illuminated by the sun.",
  },
  {
    "web-scraper-order": "1666017838-526",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌔 Waxing Gibbous Moon",
    "name-href": "https://emojipedia.org/waxing-gibbous-moon/",
    emoji: "🌔",
    emojiName: "🌔 Waxing Gibbous Moon",
    description:
      "A waxing gibbous moon (appearing more than half full and getting larger), the fourth of the eight phases of the moon. Depicts the moon as a cratered disc, mostly illuminated in gold or silver, but with its left side a dark crescent.",
  },
  {
    "web-scraper-order": "1666017841-527",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌓 First Quarter Moon",
    "name-href": "https://emojipedia.org/first-quarter-moon/",
    emoji: "🌓",
    emojiName: "🌓 First Quarter Moon",
    description:
      "A first quarter moon, the third of the eight phases of the moon. Depicts the moon as a cratered disc, its right half illuminated in gold or silver, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017844-528",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌒 Waxing Crescent Moon",
    "name-href": "https://emojipedia.org/waxing-crescent-moon/",
    emoji: "🌒",
    emojiName: "🌒 Waxing Crescent Moon",
    description:
      "A waxing crescent moon (appearing to become larger), the second of the eight phases of the moon. Depicts the moon as a cratered disc, its right side illuminated in a thin, golden or silver crescent, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017847-529",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌑 New Moon",
    "name-href": "https://emojipedia.org/new-moon/",
    emoji: "🌑",
    emojiName: "🌑 New Moon",
    description:
      "A new moon, the first of the eight phases of the moon. Depicts the moon as a full, bluish- or grayish-black, cratered disc, not illuminated by the sun.",
  },
  {
    "web-scraper-order": "1666017849-530",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪨 Rock",
    "name-href": "https://emojipedia.org/rock/",
    emoji: "🪨",
    emojiName: "🪨 Rock",
    description:
      "A large rock the size of a small rock. May be considered a boulder, a rock, a stone, a pebble, or a piece of dirt. The scale and meaning are context dependent.",
  },
  {
    "web-scraper-order": "1666017851-531",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌐 Globe with Meridians",
    "name-href": "https://emojipedia.org/globe-with-meridians/",
    emoji: "🌐",
    emojiName: "🌐 Globe with Meridians",
    description:
      "A stylized globe, with blue meridians (longitudes) and latitude. Depicted with light-blue grid of lines on a white, blue, or empty circle.",
  },
  {
    "web-scraper-order": "1666017854-532",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌏 Globe Showing Asia-Australia",
    "name-href": "https://emojipedia.org/globe-showing-asia-australia/",
    emoji: "🌏",
    emojiName: "🌏 Globe Showing Asia-Australia",
    description:
      "A globe, showing the continents of Asia and Australia in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017856-533",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌎 Globe Showing Americas",
    "name-href": "https://emojipedia.org/globe-showing-americas/",
    emoji: "🌎",
    emojiName: "🌎 Globe Showing Americas",
    description:
      "A globe, showing the continents of North and South America in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017858-534",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌍 Globe Showing Europe-Africa",
    "name-href": "https://emojipedia.org/globe-showing-europe-africa/",
    emoji: "🌍",
    emojiName: "🌍 Globe Showing Europe-Africa",
    description:
      "A globe, showing the continents of Europe and Africa in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017863-535",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦑 Squid",
    "name-href": "https://emojipedia.org/squid/",
    emoji: "🦑",
    emojiName: "🦑 Squid",
    description:
      "A squid, an octopus-like sea animal with ten arms. Generally depicted as a pinkish-orange giant squid, facing forward or angled to the left, with a slender, arrow-like body, small eyes, and two, long arms raised up at its sides. Platforms generally depict six arms.",
  },
  {
    "web-scraper-order": "1666017866-536",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦐 Shrimp",
    "name-href": "https://emojipedia.org/shrimp/",
    emoji: "🦐",
    emojiName: "🦐 Shrimp",
    description:
      "A shrimp (prawn), a small crustacean with a long tail. Generally depicted as a reddish-orange shrimp (as cooked) in full profile facing left, with tiny eyes, many limbs, and its long antennae curling back as its long tail curls in.",
  },
  {
    "web-scraper-order": "1666017871-537",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦞 Lobster",
    "name-href": "https://emojipedia.org/lobster/",
    emoji: "🦞",
    emojiName: "🦞 Lobster",
    description:
      "A lobster, a large crustacean with a prominent tail and pincers. Depicted as a reddish-orange lobster (as cooked) from above, with a long body and tail, short, tentacle-like eyes, and ten legs, the top of which are very large pincers.",
  },
  {
    "web-scraper-order": "1666017875-538",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦀 Crab",
    "name-href": "https://emojipedia.org/crab/",
    emoji: "🦀",
    emojiName: "🦀 Crab",
    description:
      "A crab, a squat crustacean with pincers. Depicted as a reddish-orange crab (as cooked) shown from above, with a round, shelled body, shorted, tentacle-like eyes, and ten legs, the top two of which are large pincers.",
  },
  {
    "web-scraper-order": "1666017878-539",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌰 Chestnut",
    "name-href": "https://emojipedia.org/chestnut/",
    emoji: "🌰",
    emojiName: "🌰 Chestnut",
    description:
      "The reddish-brown, acorn-shaped chestnut, tapering to a sharp tip from its light brown base on most platforms. A popular roasted snack associated with autumn and Christmas.",
  },
  {
    "web-scraper-order": "1666017880-540",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍄 Mushroom",
    "name-href": "https://emojipedia.org/mushroom/",
    emoji: "🍄",
    emojiName: "🍄 Mushroom",
    description:
      "The edible fungus of the mushroom, depicted as a toadstool with a white-spotted red cap and stem.",
  },
  {
    "web-scraper-order": "1666017882-541",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪺 Nest with Eggs",
    "name-href": "https://emojipedia.org/nest-with-eggs/",
    emoji: "🪺",
    emojiName: "🪺 Nest with Eggs",
    description: "A bird's nest with eggs inside.",
  },
  {
    "web-scraper-order": "1666017885-542",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪹 Empty Nest",
    "name-href": "https://emojipedia.org/empty-nest/",
    emoji: "🪹",
    emojiName: "🪹 Empty Nest",
    description: "An empty bird's nest.",
  },
  {
    "web-scraper-order": "1666017887-543",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍃 Leaf Fluttering in Wind",
    "name-href": "https://emojipedia.org/leaf-fluttering-in-wind/",
    emoji: "🍃",
    emojiName: "🍃 Leaf Fluttering in Wind",
    description:
      "Leaves, as fluttering in a spring or summer breeze. Depicted as one or two green, almond-shaped leaves, with gray or blue motion lines, as if swirling in the air or as the wind blowing through the trees.",
  },
  {
    "web-scraper-order": "1666017890-544",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍂 Fallen Leaf",
    "name-href": "https://emojipedia.org/fallen-leaf/",
    emoji: "🍂",
    emojiName: "🍂 Fallen Leaf",
    description:
      "Leaves, as a have changed color and fallen from a tree in fall/autumn. Depicted as two or three golden-brown, almond-shaped leaves of various sizes, with stems up, as if falling down.",
  },
  {
    "web-scraper-order": "1666017892-545",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍁 Maple Leaf",
    "name-href": "https://emojipedia.org/maple-leaf/",
    emoji: "🍁",
    emojiName: "🍁 Maple Leaf",
    description:
      "The distinctive, star-shaped leaf of the maple tree. Depicted as a reddish-orange maple leaf, as has changed color in the fall/autumn, with five pointed segments.",
  },
  {
    "web-scraper-order": "1666017896-546",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍀 Four Leaf Clover",
    "name-href": "https://emojipedia.org/four-leaf-clover/",
    emoji: "🍀",
    emojiName: "🍀 Four Leaf Clover",
    description:
      "A four-leaf clover, a symbol of good luck. Depicted as a bright green sprig of clover, with four, heart-shaped leaves.",
  },
  {
    "web-scraper-order": "1666017899-547",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☘️ Shamrock",
    "name-href": "https://emojipedia.org/shamrock/",
    emoji: "☘️",
    emojiName: "☘️ Shamrock",
    description:
      "A shamrock, a clover-like plant. Depicted as a bright green sprig with three, heart-shaped leaves.",
  },
  {
    "web-scraper-order": "1666017901-548",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌿 Herb",
    "name-href": "https://emojipedia.org/herb/",
    emoji: "🌿",
    emojiName: "🌿 Herb",
    description:
      "An herb, a plant used in cooking or medicine. Depicted as a green sprig, as of basil, sage, or oregano, generally with five or seven leaves.",
  },
  {
    "web-scraper-order": "1666017903-549",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌾 Sheaf of Rice",
    "name-href": "https://emojipedia.org/sheaf-of-rice/",
    emoji: "🌾",
    emojiName: "🌾 Sheaf of Rice",
    description:
      "A rice plant, as grown before harvesting and processing. Depicted as a sheaf of Asian rice with green leaves and yellow seed heads drooping over to the right or left. Sometimes assumed to be wheat.",
  },
  {
    "web-scraper-order": "1666017906-550",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌵 Cactus",
    "name-href": "https://emojipedia.org/cactus/",
    emoji: "🌵",
    emojiName: "🌵 Cactus",
    description:
      "A cactus, a spiky plant that grows in very dry regions. Depicted as a light-green saguaro cactus with two side arms covered in spines.",
  },
  {
    "web-scraper-order": "1666017909-551",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌴 Palm Tree",
    "name-href": "https://emojipedia.org/palm-tree/",
    emoji: "🌴",
    emojiName: "🌴 Palm Tree",
    description:
      "A palm tree, a tree-like plant, as grows by the sea. Depicted as a palm tree with long, green, feather-like leaves and a tall, brown, segmented trunk.",
  },
  {
    "web-scraper-order": "1666017911-552",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌳 Deciduous Tree",
    "name-href": "https://emojipedia.org/deciduous-tree/",
    emoji: "🌳",
    emojiName: "🌳 Deciduous Tree",
    description:
      "A deciduous tree, whose leaves change color before shedding, as 🍂 Fallen Leave, in the fall/autumn. Depicted as a generic tree with a round, lush, leafy top and brown trunk.",
  },
  {
    "web-scraper-order": "1666017913-553",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌲 Evergreen Tree",
    "name-href": "https://emojipedia.org/evergreen-tree/",
    emoji: "🌲",
    emojiName: "🌲 Evergreen Tree",
    description:
      "An evergreen tree, which keeps green leaves all year round. Depicted as a tall, dark green, cone-shaped tree with shaggy, layered leaves, as a pine or fir, showing a brown trunk.",
  },
  {
    "web-scraper-order": "1666017916-554",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪴 Potted Plant",
    "name-href": "https://emojipedia.org/potted-plant/",
    emoji: "🪴",
    emojiName: "🪴 Potted Plant",
    description: "A leafy green plant in pot. Plant type varies by platform.",
  },
  {
    "web-scraper-order": "1666017919-555",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌱 Seedling",
    "name-href": "https://emojipedia.org/seedling/",
    emoji: "🌱",
    emojiName: "🌱 Seedling",
    description:
      "A seedling, or a young plant, as a newly sprouted tree. Depicted as a tiny, light-green plant with a short stem and two leaves. Often shown freshly sprung from a small mound of brown earth.",
  },
  {
    "web-scraper-order": "1666017922-556",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌷 Tulip",
    "name-href": "https://emojipedia.org/tulip/",
    emoji: "🌷",
    emojiName: "🌷 Tulip",
    description:
      "A pink tulip flower. Depicted as a single, vertical pink tulip on a green stem.",
  },
  {
    "web-scraper-order": "1666017924-557",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌼 Blossom",
    "name-href": "https://emojipedia.org/blossom/",
    emoji: "🌼",
    emojiName: "🌼 Blossom",
    description:
      "A flower that has blossomed. Depicted as a flower with white or yellow petals, as a daisy, with a golden center.",
  },
  {
    "web-scraper-order": "1666017926-558",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌻 Sunflower",
    "name-href": "https://emojipedia.org/sunflower/",
    emoji: "🌻",
    emojiName: "🌻 Sunflower",
    description:
      "A sunflower, a tall, round flower with large yellow petals. Depicted as a single, vertical sunflower with a large, dark-brown center on a green stem.",
  },
  {
    "web-scraper-order": "1666017929-559",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌺 Hibiscus",
    "name-href": "https://emojipedia.org/hibiscus/",
    emoji: "🌺",
    emojiName: "🌺 Hibiscus",
    description:
      "A pink hibiscus, a flower that grows in warm climates. Depicted as a single, deep-pink hibiscus flower with green leaves and prominent, yellow stamen.",
  },
  {
    "web-scraper-order": "1666017932-560",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🥀 Wilted Flower",
    "name-href": "https://emojipedia.org/wilted-flower/",
    emoji: "🥀",
    emojiName: "🥀 Wilted Flower",
    description:
      "A flower that has wilted, or is dying. Generally depicted as a limp, faded red rose drooping over the to the right on a dried-out, green stem, shedding a petal.",
  },
  {
    "web-scraper-order": "1666017935-561",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌹 Rose",
    "name-href": "https://emojipedia.org/rose/",
    emoji: "🌹",
    emojiName: "🌹 Rose",
    description:
      "A red rose. Depicted as a single, vertical red rose on a green stem.",
  },
  {
    "web-scraper-order": "1666017938-562",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🏵️ Rosette",
    "name-href": "https://emojipedia.org/rosette/",
    emoji: "🏵️",
    emojiName: "🏵️ Rosette",
    description:
      "A rosette, a stylized, flower-shaped decoration often presented as an award with a ribbon or (military) medal. Appears as a motif in ancient cultures. Generally depicted as a circular, yellow-and-orange flower.",
  },
  {
    "web-scraper-order": "1666017940-563",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪷 Lotus",
    "name-href": "https://emojipedia.org/lotus/",
    emoji: "🪷",
    emojiName: "🪷 Lotus",
    description: "A pink lotus flower in full bloom.",
  },
  {
    "web-scraper-order": "1666017942-564",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💮 White Flower",
    "name-href": "https://emojipedia.org/white-flower/",
    emoji: "💮",
    emojiName: "💮 White Flower",
    description:
      "A stylized white flower. Generally depicted as a rosette-shaped cherry blossom in pink or red outline, often with a white fill.",
  },
  {
    "web-scraper-order": "1666017945-565",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌸 Cherry Blossom",
    "name-href": "https://emojipedia.org/cherry-blossom/",
    emoji: "🌸",
    emojiName: "🌸 Cherry Blossom",
    description:
      "The pink flower of a cherry blossom tree. Depicted as a single, light-pink cherry blossom with five, notched petals and red-tipped stamens in a yellow or white center.",
  },
  {
    "web-scraper-order": "1666017948-566",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💐 Bouquet",
    "name-href": "https://emojipedia.org/bouquet/",
    emoji: "💐",
    emojiName: "💐 Bouquet",
    description:
      "A bouquet of brightly colored flowers. Generally depicted as a collection of pink and yellow flowers with green stems tied together. Positioned at various angles across platforms.",
  },
  {
    "web-scraper-order": "1666017952-567",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦠 Microbe",
    "name-href": "https://emojipedia.org/microbe/",
    emoji: "🦠",
    emojiName: "🦠 Microbe",
    description:
      "A microbe, as a bacterium grown in a 🧫 Petri Dish or observed under a 🔬 Microscope. Generally depicted as a squiggly, single-celled microorganism with prominent cilia. Color, shape, and position vary across platforms. Commonly used to represent bacteria, viruses, and germs and disease more generally.",
  },
  {
    "web-scraper-order": "1666017956-568",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪱 Worm",
    "name-href": "https://emojipedia.org/worm/",
    emoji: "🪱",
    emojiName: "🪱 Worm",
    description:
      "A pink or brown worm. Most platforms have more realistic designs, though Google and Samsung feature cartoony worms who are smiling sweetly.",
  },
  {
    "web-scraper-order": "1666017960-569",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪰 Fly",
    "name-href": "https://emojipedia.org/fly/",
    emoji: "🪰",
    emojiName: "🪰 Fly",
    description:
      "A fly with a dark or iridescent green body, six legs, and two translucent wings. On most platforms, its eyes are red.",
  },
  {
    "web-scraper-order": "1666017963-570",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦟 Mosquito",
    "name-href": "https://emojipedia.org/mosquito/",
    emoji: "🦟",
    emojiName: "🦟 Mosquito",
    description:
      "A mosquito, a type of bloodsucking fly. Depicted as a brown or black mosquito on its six, long legs, with wings, long abdomen, and needle-like mouth. Variously shown from above or facing left.",
  },
  {
    "web-scraper-order": "1666017967-571",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦂 Scorpion",
    "name-href": "https://emojipedia.org/scorpion/",
    emoji: "🦂",
    emojiName: "🦂 Scorpion",
    description:
      "A scorpion, an arachnid with lobster-like pincers and a stinging tail. Depicted as a light-brown scorpion from above, often facing left, with its pincers and curving stinger raised. Shown with six or, accurately, eight legs in addition to its pincers.",
  },
  {
    "web-scraper-order": "1666017972-572",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕸️ Spider Web",
    "name-href": "https://emojipedia.org/spider-web/",
    emoji: "🕸️",
    emojiName: "🕸️ Spider Web",
    description:
      "A classic spider web (cobweb), as spun by a 🕷️ Spider to catch prey. Depicted as a white, symmetrical, wheel-shaped web, as an orb web, with six or eight equal sectors.",
  },
  {
    "web-scraper-order": "1666017977-573",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕷️ Spider",
    "name-href": "https://emojipedia.org/spider/",
    emoji: "🕷️",
    emojiName: "🕷️ Spider",
    description:
      "A spider, an eight-legged arachnid that spins a web. Depicted as a common black spider, as a house spider or funnel-web spider, often shown from above with its large abdomen oriented at the bottom.",
  },
  {
    "web-scraper-order": "1666017982-574",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪳 Cockroach",
    "name-href": "https://emojipedia.org/cockroach/",
    emoji: "🪳",
    emojiName: "🪳 Cockroach",
    description:
      "A brown cockroach shown with antennae, six legs, and two sensory pads at its rear called cerci.",
  },
  {
    "web-scraper-order": "1666017987-575",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦗 Cricket",
    "name-href": "https://emojipedia.org/cricket/",
    emoji: "🦗",
    emojiName: "🦗 Cricket",
    description:
      "A cricket, a hopping insect that makes a chirping sound. Depicted as a brown or green cricket in full profile on its six legs facing left, with long antennae and large, bent back legs.",
  },
  {
    "web-scraper-order": "1666017992-576",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐞 Lady Beetle",
    "name-href": "https://emojipedia.org/lady-beetle/",
    emoji: "🐞",
    emojiName: "🐞 Lady Beetle",
    description:
      "A ladybug (ladybird, lady beetle), a beetle with a round, red shell with black spots. Generally depicted as a seven- or nine-spotted ladybug shown from above on its six legs, with antennae and its distinctively red-and-black, halved shell.",
  },
  {
    "web-scraper-order": "1666017996-577",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪲 Beetle",
    "name-href": "https://emojipedia.org/beetle/",
    emoji: "🪲",
    emojiName: "🪲 Beetle",
    description:
      "A green or brown beetle shown with antennae and six legs. Can be used to talk about beetles, bugs, or insects in general.",
  },
  {
    "web-scraper-order": "1666018000-578",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐝 Honeybee",
    "name-href": "https://emojipedia.org/honeybee/",
    emoji: "🐝",
    emojiName: "🐝 Honeybee",
    description:
      "A honey bee, a busy, flying insect that lives in a hive and makes honey. Depicted as a black-and-yellow bee with clear or white wings and a stinger. Variously facing left in full profile or shown from above.",
  },
  {
    "web-scraper-order": "1666018004-579",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐜 Ant",
    "name-href": "https://emojipedia.org/ant/",
    emoji: "🐜",
    emojiName: "🐜 Ant",
    description:
      "An ant, a small, industrious insect that lives in a colony. Depicted as a black or red ant in full profile on its six legs facing left, with a prominent abdomen and antennae.",
  },
  {
    "web-scraper-order": "1666018007-580",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐛 Bug",
    "name-href": "https://emojipedia.org/bug/",
    emoji: "🐛",
    emojiName: "🐛 Bug",
    description:
      "A bug, or insect, generally depicted as a caterpillar, which becomes a 🦋 Butterfly. Shown in full profile facing left, inching up on the back of its green, segmented, and textured body. Often featuring black stripes or yellow dots and tentacles on its head.",
  },
  {
    "web-scraper-order": "1666018017-581",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦋 Butterfly",
    "name-href": "https://emojipedia.org/butterfly/",
    emoji: "🦋",
    emojiName: "🦋 Butterfly",
    description:
      "A butterfly, a beautiful winged insect whose larva is a caterpillar. Depicted with its wings outspread, as a blue-and-black morpho butterfly or orange-and-black monarch butterfly.",
  },
  {
    "web-scraper-order": "1666018023-582",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐌 Snail",
    "name-href": "https://emojipedia.org/snail/",
    emoji: "🐌",
    emojiName: "🐌 Snail",
    description:
      "A snail, a slow-moving, snail-like mollusk in a spiraling shell. Generally depicted as a brown snail in full profile facing left or right, with a brown, textured shell and tentacle-like eyes.",
  },
  {
    "web-scraper-order": "1666018026-583",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪸 Coral",
    "name-href": "https://emojipedia.org/coral/",
    emoji: "🪸",
    emojiName: "🪸 Coral",
    description:
      "Coral as found in a reef, of varying shapes and colors. Sometimes used as a symbol of climate change due to coral bleaching.",
  },
  {
    "web-scraper-order": "1666018030-584",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐚 Spiral Shell",
    "name-href": "https://emojipedia.org/spiral-shell/",
    emoji: "🐚",
    emojiName: "🐚 Spiral Shell",
    description:
      "A seashell, as found at the beach. Generally depicted as an empty, spiraling, white seashell, as grown by a sea snail or home to a hermit crab. Positioned at various angles across platforms.",
  },
  {
    "web-scraper-order": "1666018034-585",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐙 Octopus",
    "name-href": "https://emojipedia.org/octopus/",
    emoji: "🐙",
    emojiName: "🐙 Octopus",
    description:
      "An octopus, a sea animal with eight legs, known to change color and release ink. Generally depicted as a pink or orange octopus facing forward, with a large, round head, prominent eyes, and its tentacle-like arms raised at its sides. Platforms vary in the number of arms shown, ranging from four to the full eight, with several designs featuring suckers on them.",
  },
  {
    "web-scraper-order": "1666018037-586",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦈 Shark",
    "name-href": "https://emojipedia.org/shark/",
    emoji: "🦈",
    emojiName: "🦈 Shark",
    description:
      "A shark, a large, stealthy fish with many teeth. Generally depicted as a gray shark in full profile facing left, as a tiger, bull, or great white shark hunting in the water. Shown with a white underside and three gills, its pointed nose and teeth-lined mouth curving down to a sharp dorsal fin and long, pointed tail.",
  },
  {
    "web-scraper-order": "1666018046-587",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐡 Blowfish",
    "name-href": "https://emojipedia.org/blowfish/",
    emoji: "🐡",
    emojiName: "🐡 Blowfish",
    description:
      "A blowfish (puffer), which puffs up and becomes spiky when alarmed. Depicted as an orange or brown blowfish in full profile facing left, with small fins, a white underside, and a round, spiky body, as if inflated.",
  },
  {
    "web-scraper-order": "1666018049-588",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐠 Tropical Fish",
    "name-href": "https://emojipedia.org/tropical-fish/",
    emoji: "🐠",
    emojiName: "🐠 Tropical Fish",
    description:
      "A tropical fish, as swims in the warm waters of a coral reef or is kept as a pet in an aquarium. Depicted as a brightly colored fish in full profile facing left, with slender fins. Often shown as a blue-and-yellow fish with stripes, as an angelfish.",
  },
  {
    "web-scraper-order": "1666018053-589",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐟 Fish",
    "name-href": "https://emojipedia.org/fish/",
    emoji: "🐟",
    emojiName: "🐟 Fish",
    description:
      "A common fish, as swims in the water. Depicted as a generic, light-blue fish, often with a white underside, in full profile facing left, with fins and prominent gill cover.",
  },
  {
    "web-scraper-order": "1666018057-590",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦭 Seal",
    "name-href": "https://emojipedia.org/seal/",
    emoji: "🦭",
    emojiName: "🦭 Seal",
    description:
      "A gray seal with dark eyes and a dark nose. Most platforms feature a design with whiskers.",
  },
  {
    "web-scraper-order": "1666018060-591",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐬 Dolphin",
    "name-href": "https://emojipedia.org/dolphin/",
    emoji: "🐬",
    emojiName: "🐬 Dolphin",
    description:
      "A dolphin, a sleek marine mammal known to be social and intelligent. Generally depicted as a light-blue dolphin with a white belly in full profile facing left, its short snout curving down to a prominent dorsal fin and tail, as a bottlenose dolphin leaping in the air.",
  },
  {
    "web-scraper-order": "1666018064-592",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐋 Whale",
    "name-href": "https://emojipedia.org/whale/",
    emoji: "🐋",
    emojiName: "🐋 Whale",
    description:
      "A whale, the massive marine mammal. Generally depicted as a light-blue whale in full profile facing left, with its tail curving down towards is huge mouth. Shown with a white, textured underside, as a humpback or blue whale.",
  },
  {
    "web-scraper-order": "1666018069-593",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐳 Spouting Whale",
    "name-href": "https://emojipedia.org/spouting-whale/",
    emoji: "🐳",
    emojiName: "🐳 Spouting Whale",
    description:
      "A friendly, cartoon-styled whale, shown spouting water from its blowhole. Generally depicted as a light-blue whale in full profile facing left, with a round body and white underside, its tail held upright.",
  },
  {
    "web-scraper-order": "1666018073-594",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦖 T-Rex",
    "name-href": "https://emojipedia.org/t-rex/",
    emoji: "🦖",
    emojiName: "🦖 T-Rex",
    description:
      "A Tyrannosaurus rex, a massive, meat-eating dinosaur with huge jaws, tiny arms, and a long tail. Depicted as a green tyrannosaur standing on its hind lefts facing left, often with a textured back, sharp teeth, and clawed toes.",
  },
  {
    "web-scraper-order": "1666018075-595",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦕 Sauropod",
    "name-href": "https://emojipedia.org/sauropod/",
    emoji: "🦕",
    emojiName: "🦕 Sauropod",
    description:
      "A sauropod, a massive, plant-eating dinosaur with a long neck and tail. Depicted as a blue, gray, or green sauropod, as a brachiosaurus, apatosaurus/brontosaurus, or diplodocus. Shown in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018080-596",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐉 Dragon",
    "name-href": "https://emojipedia.org/dragon/",
    emoji: "🐉",
    emojiName: "🐉 Dragon",
    description:
      "A dragon, a mythical creature resembling a giant reptile found in the folklore of many cultures. Depicted as a green, Chinese-styled dragon in full profile facing left. Generally shown with a curling, snake-like body, clawed feet, yellowish scales on its back, horn-like structures on its head, and whisker-like tendrils by its nostrils.",
  },
  {
    "web-scraper-order": "1666018084-597",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐲 Dragon Face",
    "name-href": "https://emojipedia.org/dragon-face/",
    emoji: "🐲",
    emojiName: "🐲 Dragon Face",
    description:
      "The face of a dragon, a mythical creature resembling a giant reptile found in the folklore of many cultures. Depicted as a green, Chinese-styled dragon looking straight ahead or facing left. Often shown with huge nostrils, baring large teeth and a red tongue, with antler-like structures on its head, whisker-like tendrils by its nostrils, and a green or yellow mane.",
  },
  {
    "web-scraper-order": "1666018089-598",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐍 Snake",
    "name-href": "https://emojipedia.org/snake/",
    emoji: "🐍",
    emojiName: "🐍 Snake",
    description:
      "A snake, a slithering reptile without limbs. Generally depicted as a yellowish-green snake facing left, with a long, coiled body and flicking a red, forked tongue.",
  },
  {
    "web-scraper-order": "1666018092-599",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦎 Lizard",
    "name-href": "https://emojipedia.org/lizard/",
    emoji: "🦎",
    emojiName: "🦎 Lizard",
    description:
      "A lizard, a scaly reptile with a long tail. Depicted as a light-green lizard on all fours from above, generally looking left with large eyes, a lightly textured or colored back, and toes outspread, as a gecko.",
  },
  {
    "web-scraper-order": "1666018099-600",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐢 Turtle",
    "name-href": "https://emojipedia.org/turtle/",
    emoji: "🐢",
    emojiName: "🐢 Turtle",
    description:
      "A turtle, a slow-moving reptile with a shell. Depicted as a light-green turtle in full profile on all fours facing left, with a long neck and green, textured shell.",
  },
  {
    "web-scraper-order": "1666018103-601",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐊 Crocodile",
    "name-href": "https://emojipedia.org/crocodile/",
    emoji: "🐊",
    emojiName: "🐊 Crocodile",
    description:
      "A crocodile, a stealthy reptile with massive jaws. Generally depicted as a light-green crocodile on all fours, with its long tail curving down to its toothed jaws, facing left.",
  },
  {
    "web-scraper-order": "1666018108-602",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐸 Frog",
    "name-href": "https://emojipedia.org/frog/",
    emoji: "🐸",
    emojiName: "🐸 Frog",
    description:
      "The face of a frog, the hopping amphibian. Generally depicted as a friendly, cartoon-styled, light-green frog looking straight ahead, with large eyes, slightly open mouth, and nostrils.",
  },
  {
    "web-scraper-order": "1666018112-603",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦜 Parrot",
    "name-href": "https://emojipedia.org/parrot/",
    emoji: "🦜",
    emojiName: "🦜 Parrot",
    description:
      "A parrot, a brightly colored bird known for its ability to mimic speech. Depicted in full profile facing left. Resembles a green lovebird with red and yellow wings on some platforms and a scarlet macaw with blue and yellow wings on others.",
  },
  {
    "web-scraper-order": "1666018116-604",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦚 Peacock",
    "name-href": "https://emojipedia.org/peacock/",
    emoji: "🦚",
    emojiName: "🦚 Peacock",
    description:
      "A peacock, the male bird that displays a large, fan-like, iridescent tale. Depicted facing forward standing on its legs, with a blue body and green tail feathers outspread.",
  },
  {
    "web-scraper-order": "1666018119-605",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦩 Flamingo",
    "name-href": "https://emojipedia.org/flamingo/",
    emoji: "🦩",
    emojiName: "🦩 Flamingo",
    description:
      "A flamingo, a waterbird with pink feathers and long neck and legs. Depicted as a flamingo in full profile facing left, standing on one leg, usually with a long, black beak.",
  },
  {
    "web-scraper-order": "1666018122-606",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪶 Feather",
    "name-href": "https://emojipedia.org/feather/",
    emoji: "🪶",
    emojiName: "🪶 Feather",
    description:
      "A single feather slanted to one side. On most platforms it's light brown with a dark brown barred or striped pattern. Can be used to talk about feathers or birds, or to represent something that is lightweight, fluffy, or soft.",
  },
  {
    "web-scraper-order": "1666018127-607",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦤 Dodo",
    "name-href": "https://emojipedia.org/dodo/",
    emoji: "🦤",
    emojiName: "🦤 Dodo",
    description:
      "A brown or gray dodo shown in full profile. Generally depicted with a curved yellow beak, small wings, a fluffy white tail, yellow or orange feet, and black talons.",
  },
  {
    "web-scraper-order": "1666018131-608",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦉 Owl",
    "name-href": "https://emojipedia.org/owl/",
    emoji: "🦉",
    emojiName: "🦉 Owl",
    description:
      "An owl, the hooting, large-eyed bird. Depicted as a brown owl with its head facing forward. Shown with large, round, gold-rimmed eyes, talons, tucked wings, and horn-like tufts of feathers.",
  },
  {
    "web-scraper-order": "1666018135-609",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦢 Swan",
    "name-href": "https://emojipedia.org/swan/",
    emoji: "🦢",
    emojiName: "🦢 Swan",
    description:
      "A swan, a waterbird with white feathers and a long neck. Depicted in full profile facing left, with a curving neck, orange bill, black eye marking, and wings and legs tucked in, as if gliding in water.",
  },
  {
    "web-scraper-order": "1666018139-610",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦆 Duck",
    "name-href": "https://emojipedia.org/duck/",
    emoji: "🦆",
    emojiName: "🦆 Duck",
    description:
      "Quack! A duck, a waterbird with webbed feet. Depicted as a male (drake) mallard in full profile facing left, standing on its legs with gray and brown feathers, a yellow bill, and its distinctive green head.",
  },
  {
    "web-scraper-order": "1666018142-611",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦅 Eagle",
    "name-href": "https://emojipedia.org/eagle/",
    emoji: "🦅",
    emojiName: "🦅 Eagle",
    description:
      "A bald eagle, the majestic bird of prey with brown feathers and distinctive white head. Generally depicted facing left, with its wings outspread and talons out, as if swooping down to seize prey.",
  },
  {
    "web-scraper-order": "1666018146-612",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕊️ Dove",
    "name-href": "https://emojipedia.org/dove/",
    emoji: "🕊️",
    emojiName: "🕊️ Dove",
    description:
      "A dove carrying an olive branch, a symbol of peace in Western and Judeo-Christian culture. Depicted as a white bird in full profile facing left, flying as it holds a green sprig in its beak.",
  },
  {
    "web-scraper-order": "1666018149-613",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐧 Penguin",
    "name-href": "https://emojipedia.org/penguin/",
    emoji: "🐧",
    emojiName: "🐧 Penguin",
    description:
      "A penguin, a flightless bird adapted to water and ice. Variously depicted as a full, black-bodied penguin with a white belly and orange bill or as a penguin head.",
  },
  {
    "web-scraper-order": "1666018153-614",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐦 Bird",
    "name-href": "https://emojipedia.org/bird/",
    emoji: "🐦",
    emojiName: "🐦 Bird",
    description:
      "A generic bird. Variously depicted as a blue or red bird, as a bluebird or cardinal, shown standing in full profile, or as a bird head. Both designs show the bird facing left.",
  },
  {
    "web-scraper-order": "1666018157-615",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐥 Front-Facing Baby Chick",
    "name-href": "https://emojipedia.org/front-facing-baby-chick/",
    emoji: "🐥",
    emojiName: "🐥 Front-Facing Baby Chick",
    description:
      "A baby chicken (chick), shown as if flapping its wings. Depicted as a yellow chick with an orange beak in full profile standing on its legs, generally with its wings raised.",
  },
  {
    "web-scraper-order": "1666018162-616",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐤 Baby Chick",
    "name-href": "https://emojipedia.org/baby-chick/",
    emoji: "🐤",
    emojiName: "🐤 Baby Chick",
    description:
      "A yellow baby chicken (chick). Variously depicted as a chick in full profile, standing on its legs, or as a chick head. Both designs show the bird facing left, with an orange beak and feet.",
  },
  {
    "web-scraper-order": "1666018174-617",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐣 Hatching Chick",
    "name-href": "https://emojipedia.org/hatching-chick/",
    emoji: "🐣",
    emojiName: "🐣 Hatching Chick",
    description:
      "A baby chicken (chick), hatching from an egg and seeing the world for the first time. Depicted as a yellow chick with an orange beak facing forward in the cracked, bottom half of a white egg, generally shown flapping its wings with a cute facial expression.",
  },
  {
    "web-scraper-order": "1666018178-618",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐓 Rooster",
    "name-href": "https://emojipedia.org/rooster/",
    emoji: "🐓",
    emojiName: "🐓 Rooster",
    description:
      "A rooster (cock), a male chicken known for its cock-a-doodle-do. Depicted as a white or multicolored rooster standing on its legs in full profile facing left, with a red comb on its head and red wattle on its neck.",
  },
  {
    "web-scraper-order": "1666018181-619",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐔 Chicken",
    "name-href": "https://emojipedia.org/chicken/",
    emoji: "🐔",
    emojiName: "🐔 Chicken",
    description:
      "A chicken, a bird used for its meat and eggs. Generally depicted as the white head of a chicken (hen or rooster) looking left, with a yellow beak, red comb on its head, and red wattle on its neck.",
  },
  {
    "web-scraper-order": "1666018186-620",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦃 Turkey",
    "name-href": "https://emojipedia.org/turkey/",
    emoji: "🦃",
    emojiName: "🦃 Turkey",
    description:
      "A turkey, a gobbling bird traditionally eaten at Thanksgiving or Christmas. Depicted in full profile facing left, standing on its legs with a dark-brown body, a white-fringed plume, pink or blue head, and its distinctive red snood and wattle.",
  },
  {
    "web-scraper-order": "1666018189-621",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐾 Paw Prints",
    "name-href": "https://emojipedia.org/paw-prints/",
    emoji: "🐾",
    emojiName: "🐾 Paw Prints",
    description:
      "A pair of paw prints, as left by a pet 🐈 cat or 🐕 dog. Generally depicted as two, staggered, dark-colored paw prints, each showing four toes and a pad.",
  },
  {
    "web-scraper-order": "1666018192-622",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦡 Badger",
    "name-href": "https://emojipedia.org/badger/",
    emoji: "🦡",
    emojiName: "🦡 Badger",
    description:
      "A badger, a stocky mammal in the weasel family with a long, pointed head. Generally depicted in full profile on all fours facing left, with a gray coat, black-and-white-striped face, and short tail.",
  },
  {
    "web-scraper-order": "1666018195-623",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦘 Kangaroo",
    "name-href": "https://emojipedia.org/kangaroo/",
    emoji: "🦘",
    emojiName: "🦘 Kangaroo",
    description:
      "A kangaroo, a marsupial with a large tail and legs. Depicted in yellowish-brown in full profile facing left with large, pointed ears, shown either resting on its hind legs and tail or jumping.",
  },
  {
    "web-scraper-order": "1666018199-624",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦨 Skunk",
    "name-href": "https://emojipedia.org/skunk/",
    emoji: "🦨",
    emojiName: "🦨 Skunk",
    description:
      "A skunk, a bushy-tailed mammal that sprays a foul odor when threatened. Depicted in full profile on all fours facing left, with black hair and its distinctive white stripe running from its head down to a curled-up tail.",
  },
  {
    "web-scraper-order": "1666018203-625",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦦 Otter",
    "name-href": "https://emojipedia.org/otter/",
    emoji: "🦦",
    emojiName: "🦦 Otter",
    description:
      "An otter, the playful water mammal in the weasel family. Depicted as a light-brown otter on its back, with its forepaws held together and whiskered face to the left, generally with its long tail curled up.",
  },
  {
    "web-scraper-order": "1666018210-626",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦥 Sloth",
    "name-href": "https://emojipedia.org/sloth/",
    emoji: "🦥",
    emojiName: "🦥 Sloth",
    description:
      "A sloth, the slow-moving, tree-dwelling mammal. Depicted as a light-brown sloth with a wide, whitish, masked face hanging from a tree branch, facing left or right. Generally shown as a three-toed sloth.",
  },
  {
    "web-scraper-order": "1666018216-627",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐼 Panda",
    "name-href": "https://emojipedia.org/panda/",
    emoji: "🐼",
    emojiName: "🐼 Panda",
    description:
      "A friendly, cartoon-styled face of a panda—a bear-like mammal known for eating bamboo—looking straight ahead. Depicted as a white panda face with black ears and black circles around its eyes.",
  },
  {
    "web-scraper-order": "1666018220-628",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐨 Koala",
    "name-href": "https://emojipedia.org/koala/",
    emoji: "🐨",
    emojiName: "🐨 Koala",
    description:
      "A friendly, cartoon-styled face of a koala—a bear-like marsupial known for eating eucalyptus and sleeping—looking straight ahead. Depicted as a gray face with round, fluffy ears and a large, black nose.",
  },
  {
    "web-scraper-order": "1666018225-629",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐻‍❄️ Polar Bear",
    "name-href": "https://emojipedia.org/polar-bear/",
    emoji: "🐻‍❄️",
    emojiName: "🐻‍❄️ Polar Bear",
    description:
      "A friendly, cartoon-styled face of polar bear, looking straight ahead. Depicted as the face of a white bear with round ears.",
  },
  {
    "web-scraper-order": "1666018230-630",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐻 Bear",
    "name-href": "https://emojipedia.org/bear/",
    emoji: "🐻",
    emojiName: "🐻 Bear",
    description:
      "A friendly, cartoon-styled face of bear, looking straight ahead. Depicted as a brown bear with round ears and a tan muzzle. Resembles a teddy bear.",
  },
  {
    "web-scraper-order": "1666018234-631",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦇 Bat",
    "name-href": "https://emojipedia.org/bat/",
    emoji: "🦇",
    emojiName: "🦇 Bat",
    description:
      "A bat, the flying mammal of the night. Variously depicted as a brown, black, or gray bat, with wings outspread and pointy ears, facing forward or left.",
  },
  {
    "web-scraper-order": "1666018238-632",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦔 Hedgehog",
    "name-href": "https://emojipedia.org/hedgehog/",
    emoji: "🦔",
    emojiName: "🦔 Hedgehog",
    description:
      "A hedgehog. A small, spiny mammal sometimes kept as a pet. Generally depicted in full profile on all fours facing left, with a round, brown body covered with spines and a light-brown face and underside.",
  },
  {
    "web-scraper-order": "1666018243-633",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦫 Beaver",
    "name-href": "https://emojipedia.org/beaver/",
    emoji: "🦫",
    emojiName: "🦫 Beaver",
    description:
      "A brown beaver with buckteeth and a wide paddle-like tail. Can be used in the context of actual beavers, or metaphorically to evoke qualities of beavers like working hard, as in the expression beavering away.",
  },
  {
    "web-scraper-order": "1666018247-634",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐿️ Chipmunk",
    "name-href": "https://emojipedia.org/chipmunk/",
    emoji: "🐿️",
    emojiName: "🐿️ Chipmunk",
    description:
      "A chipmunk, a small rodent with puffy cheeks. Depicted as a brown chipmunk in full profile facing left, sitting on its hind legs with a bushy tail and striped body. Generally holding an acorn or other nut in its hands.",
  },
  {
    "web-scraper-order": "1666018252-635",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐇 Rabbit",
    "name-href": "https://emojipedia.org/rabbit/",
    emoji: "🐇",
    emojiName: "🐇 Rabbit",
    description:
      "A rabbit, a hoppy mammal with long ears. Depicted as a white, gray, or brown rabbit in full profile facing left with pink ears and a short tail, sitting on its long, hind legs or on all fours.",
  },
  {
    "web-scraper-order": "1666018257-636",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐰 Rabbit Face",
    "name-href": "https://emojipedia.org/rabbit-face/",
    emoji: "🐰",
    emojiName: "🐰 Rabbit Face",
    description:
      "A friendly, cartoon-styled face of a rabbit, looking straight ahead. Generally depicted as a gray and/or white rabbit face with upright ears and pink ears and nose, often with whiskers and a buck tooth.",
  },
  {
    "web-scraper-order": "1666018262-637",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐹 Hamster",
    "name-href": "https://emojipedia.org/hamster/",
    emoji: "🐹",
    emojiName: "🐹 Hamster",
    description:
      "A friendly, cartoon-styled face of a hamster—a small rodent often kept as a pet—looking straight ahead. Generally depicted as a brown-and-white faced hamster with whiskers, a pink nose, puffy cheeks, and large, round, pink ears, sometimes with a buck tooth.",
  },
  {
    "web-scraper-order": "1666018266-638",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐀 Rat",
    "name-href": "https://emojipedia.org/rat/",
    emoji: "🐀",
    emojiName: "🐀 Rat",
    description:
      "A rat, a large rodent with a long tail, known to frequent big cities. Depicted in gray in full profile on all fours facing left, with pink ears, feet, and tail.",
  },
  {
    "web-scraper-order": "1666018270-639",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐁 Mouse",
    "name-href": "https://emojipedia.org/mouse/",
    emoji: "🐁",
    emojiName: "🐁 Mouse",
    description:
      "Eek! A mouse, a small rodent with large ears and a long tail. Generally depicted in white in full profile on all fours facing left, with pink ears, feet, and tail, often with reddish eyes.",
  },
  {
    "web-scraper-order": "1666018274-640",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐭 Mouse Face",
    "name-href": "https://emojipedia.org/mouse-face/",
    emoji: "🐭",
    emojiName: "🐭 Mouse Face",
    description:
      "A friendly, cartoon-styled face of a mouse, looking straight ahead. Generally depicted as a gray or white mouse face with large, round ears, a pink, pointed nose, and whiskers.",
  },
  {
    "web-scraper-order": "1666018278-641",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦛 Hippopotamus",
    "name-href": "https://emojipedia.org/hippopotamus/",
    emoji: "🦛",
    emojiName: "🦛 Hippopotamus",
    description:
      "A hippopotamus, a squat water mammal with huge jaws. Generally depicted in gray or tan in full profile facing left.",
  },
  {
    "web-scraper-order": "1666018283-642",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦏 Rhinoceros",
    "name-href": "https://emojipedia.org/rhinoceros/",
    emoji: "🦏",
    emojiName: "🦏 Rhinoceros",
    description:
      "A rhinoceros, a large mammal with one or two massive horns on its nose. Generally shown in light gray with two horns, depicted in full profile on all fours or as a rhinoceros head looking left.",
  },
  {
    "web-scraper-order": "1666018287-643",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦣 Mammoth",
    "name-href": "https://emojipedia.org/mammoth/",
    emoji: "🦣",
    emojiName: "🦣 Mammoth",
    description:
      "A brown wooly mammoth with large curved tusks. Can also be used to represent a mastodon.",
  },
  {
    "web-scraper-order": "1666018292-644",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐘 Elephant",
    "name-href": "https://emojipedia.org/elephant/",
    emoji: "🐘",
    emojiName: "🐘 Elephant",
    description:
      "An elephant, the largest land animal on Earth, with a long trunk and, often, tusks. Generally depicted in gray in full profile on all fours facing left, with tusks and prominent ears, as an African (vs. Asian) elephant.",
  },
  {
    "web-scraper-order": "1666018295-645",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦒 Giraffe",
    "name-href": "https://emojipedia.org/giraffe/",
    emoji: "🦒",
    emojiName: "🦒 Giraffe",
    description:
      "A giraffe, the tallest animal on Earth, with spots and a long neck. Generally depicted in yellow or tan in full profile on all fours facing left, with distinctive brown spots and small, horn-like structures.",
  },
  {
    "web-scraper-order": "1666018299-646",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦙 Llama",
    "name-href": "https://emojipedia.org/llama/",
    emoji: "🦙",
    emojiName: "🦙 Llama",
    description:
      "A llama, a long-necked, camel-like animal, native to South America and used for transport and wool. Depicted as a shaggy white, light-brown, or multicolored llama in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018303-647",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐫 Two-Hump Camel",
    "name-href": "https://emojipedia.org/two-hump-camel/",
    emoji: "🐫",
    emojiName: "🐫 Two-Hump Camel",
    description:
      "A Bactrian camel, a long-necked mammal with two large humps on its back. Depicted in light or yellowish brown, sometimes with a shaggy mane and humps, in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018306-648",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐪 Camel",
    "name-href": "https://emojipedia.org/camel/",
    emoji: "🐪",
    emojiName: "🐪 Camel",
    description:
      "A dromedary camel, a long-necked mammal with one large hump on its back. Depicted in light or yellowish brown in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018310-649",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐐 Goat",
    "name-href": "https://emojipedia.org/goat/",
    emoji: "🐐",
    emojiName: "🐐 Goat",
    description:
      "A goat, a sturdy, hoofed animal raised for its meat and milk. Depicted as a light brown, white, or multicored goat in full profile on all fours facing left, a scraggly beard, upright tail, and brown or yellow horns curving back.",
  },
  {
    "web-scraper-order": "1666018314-650",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐑 Ewe",
    "name-href": "https://emojipedia.org/ewe/",
    emoji: "🐑",
    emojiName: "🐑 Ewe",
    description:
      "A ewe, or female sheep raised for its wool, meat, and milk and without the spiraling horns of a ram. Depicted in full profile on all fours facing left with a thick, white fleece and black, gray, or white skin.",
  },
  {
    "web-scraper-order": "1666018319-651",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐏 Ram",
    "name-href": "https://emojipedia.org/ram/",
    emoji: "🐏",
    emojiName: "🐏 Ram",
    description:
      "A ram, a male sheep with large, spiraling horns. Generally depicted in full profile on all fours facing left with a thick, white fleece and light-brown horns.",
  },
  {
    "web-scraper-order": "1666018323-652",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐽 Pig Nose",
    "name-href": "https://emojipedia.org/pig-nose/",
    emoji: "🐽",
    emojiName: "🐽 Pig Nose",
    description:
      "The snout of a pig. Depicted as a pink oval or slightly pear-shaped nose with two black nostrils.",
  },
  {
    "web-scraper-order": "1666018327-653",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐗 Boar",
    "name-href": "https://emojipedia.org/boar/",
    emoji: "🐗",
    emojiName: "🐗 Boar",
    description:
      "A boar, a hairy, wild pig with tusks. Generally depicted as the face of a brown boar, either facing left or looking straight ahead, with prominent tusks projecting from its lower jaw.",
  },
  {
    "web-scraper-order": "1666018330-654",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐖 Pig",
    "name-href": "https://emojipedia.org/pig/",
    emoji: "🐖",
    emojiName: "🐖 Pig",
    description:
      "A pig, a plump animal farmed for its meat, such as bacon. Depicted in light pink in full profile on all fours facing left, with a long snout and short, curly tail.",
  },
  {
    "web-scraper-order": "1666018335-655",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐷 Pig Face",
    "name-href": "https://emojipedia.org/pig-face/",
    emoji: "🐷",
    emojiName: "🐷 Pig Face",
    description:
      "A friendly, cartoon-styled face of a pig looking straight ahead. Depicted as a pink face with a neutral expression, pointed or floppy ears, and distinctive pig nose.",
  },
  {
    "web-scraper-order": "1666018339-656",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐄 Cow",
    "name-href": "https://emojipedia.org/cow/",
    emoji: "🐄",
    emojiName: "🐄 Cow",
    description:
      "A cow, a bovine farmed for its meat or milk. Depicted in full profile on all fours facing left with a black-and-white patched coat (as a Holstein Friesian) and, on many platforms, a pink udder and horns.",
  },
  {
    "web-scraper-order": "1666018343-657",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐃 Water Buffalo",
    "name-href": "https://emojipedia.org/water-buffalo/",
    emoji: "🐃",
    emojiName: "🐃 Water Buffalo",
    description:
      "A water buffalo, a bovine used to plough rice fields in parts of Asia. Depicted in gray or black in full profile on all fours facing left, with a tail and broad horns curled up at the tips.",
  },
  {
    "web-scraper-order": "1666018347-658",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐂 Ox",
    "name-href": "https://emojipedia.org/ox/",
    emoji: "🐂",
    emojiName: "🐂 Ox",
    description:
      "An ox, a bovine used as a draft animal. Depicted in brown in full profile on all fours facing left, with a tail and short horns.",
  },
  {
    "web-scraper-order": "1666018352-659",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐮 Cow Face",
    "name-href": "https://emojipedia.org/cow-face/",
    emoji: "🐮",
    emojiName: "🐮 Cow Face",
    description:
      "A friendly, cartoon-styled face of a cow looking straight ahead. Variously depicted as a white, brown, or multicolored cow face with a neutral expression, short horns, and a pink or brown muzzle.",
  },
  {
    "web-scraper-order": "1666018356-660",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦬 Bison",
    "name-href": "https://emojipedia.org/bison/",
    emoji: "🦬",
    emojiName: "🦬 Bison",
    description:
      "A brown bison shown in full profile with horns, a beard, and woolly mane. Also called a buffalo in North America.",
  },
  {
    "web-scraper-order": "1666018360-661",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦌 Deer",
    "name-href": "https://emojipedia.org/deer/",
    emoji: "🦌",
    emojiName: "🦌 Deer",
    description:
      "A deer, a fleet-footed, hoofed mammal whose males (bucks, stags) generally have antlers. Variously depicted as a light-brown deer in full profile on all fours facing left or as a deer face looking straight head; both depictions feature large, branched antlers.",
  },
  {
    "web-scraper-order": "1666018365-662",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦓 Zebra",
    "name-href": "https://emojipedia.org/zebra/",
    emoji: "🦓",
    emojiName: "🦓 Zebra",
    description:
      "A zebra, a horse-like mammal with black-and-white stripes. Variously depicted in full profile on all fours facing left or as a zebra head facing left with a short mane.",
  },
  {
    "web-scraper-order": "1666018369-663",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦄 Unicorn",
    "name-href": "https://emojipedia.org/unicorn/",
    emoji: "🦄",
    emojiName: "🦄 Unicorn",
    description:
      "The face of a unicorn, a mythical creature in the form of a white horse with a single, long horn on its forehead. Generally depicted as a white horse head facing left with a pink or purple mane and a yellow or rainbow-colored horn.",
  },
  {
    "web-scraper-order": "1666018373-664",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐎 Horse",
    "name-href": "https://emojipedia.org/horse/",
    emoji: "🐎",
    emojiName: "🐎 Horse",
    description:
      "A horse, a hoofed mammal used for riding and racing. Depicted as a brown horse in full profile galloping to the left, with a dark, flowing mane and tail.",
  },
  {
    "web-scraper-order": "1666018378-665",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐴 Horse Face",
    "name-href": "https://emojipedia.org/horse-face/",
    emoji: "🐴",
    emojiName: "🐴 Horse Face",
    description:
      "The face of a horse, generally facing left. Depicted as a light or reddish-brown horse with a dark brown or black mane, and, on many platforms, a light-colored muzzle.",
  },
  {
    "web-scraper-order": "1666018382-666",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐆 Leopard",
    "name-href": "https://emojipedia.org/leopard/",
    emoji: "🐆",
    emojiName: "🐆 Leopard",
    description:
      "A leopard, a large cat with a yellowish-brown coat and black-and-gold spots. Depicted in full profile on all fours facing left, with a long tail and its distinctive pattern.",
  },
  {
    "web-scraper-order": "1666018386-667",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐅 Tiger",
    "name-href": "https://emojipedia.org/tiger/",
    emoji: "🐅",
    emojiName: "🐅 Tiger",
    description:
      "A tiger, a large cat with an orange coat and black stripes. Depicted in full profile on all fours facing left, with a long tail, its distinctive stripes, and, on some platforms, white patches.",
  },
  {
    "web-scraper-order": "1666018391-668",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐯 Tiger Face",
    "name-href": "https://emojipedia.org/tiger-face/",
    emoji: "🐯",
    emojiName: "🐯 Tiger Face",
    description:
      "A friendly, cartoon-styled face of a tiger looking straight ahead. Generally depicted in yellowish-orange with black stripes on its forehead and cheeks, a white muzzle, and neutral expression.",
  },
  {
    "web-scraper-order": "1666018396-669",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦁 Lion",
    "name-href": "https://emojipedia.org/lion/",
    emoji: "🦁",
    emojiName: "🦁 Lion",
    description:
      "A friendly, cartoon-styled face of a lion—the large cat and king of the jungle—looking straight ahead. Depicted as a golden-yellow lion face with a light- or dark-brown mane, white muzzle, and neutral expression.",
  },
  {
    "web-scraper-order": "1666018400-670",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐈‍⬛ Black Cat",
    "name-href": "https://emojipedia.org/black-cat/",
    emoji: "🐈‍⬛",
    emojiName: "🐈‍⬛ Black Cat",
    description:
      "A black cat shown in full profile, often with its tail curling upward.",
  },
  {
    "web-scraper-order": "1666018405-671",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐈 Cat",
    "name-href": "https://emojipedia.org/cat/",
    emoji: "🐈",
    emojiName: "🐈 Cat",
    description:
      "A domestic cat, beloved as a pet. Generally depicted as a light-orange cat with stripes, as a tabby, in full profile on all fours facing left, with its long tell held upright.",
  },
  {
    "web-scraper-order": "1666018409-672",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐱 Cat Face",
    "name-href": "https://emojipedia.org/cat-face/",
    emoji: "🐱",
    emojiName: "🐱 Cat Face",
    description:
      "Meow! A friendly, cartoon-styled face of a cat, looking straight ahead. Generally depicted as a yellowish-orange cat face with pointed ears and whiskers.",
  },
  {
    "web-scraper-order": "1666018414-673",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦝 Raccoon",
    "name-href": "https://emojipedia.org/raccoon/",
    emoji: "🦝",
    emojiName: "🦝 Raccoon",
    description:
      "A raccoon, a nocturnal mammal with a mask around its eyes. Generally depicted as a friendly, cartoon-styled, gray raccoon face looking straight ahead, with black-and-white markings around its eyes and pointed ears and cheeks.",
  },
  {
    "web-scraper-order": "1666018419-674",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦊 Fox",
    "name-href": "https://emojipedia.org/fox/",
    emoji: "🦊",
    emojiName: "🦊 Fox",
    description:
      "A friendly, cartoon-styled faced of a fox, the cunning canine, looking straight ahead. Depicted as an orange fox  face with a black nose, pointed ears, and shaggy, white cheeks.",
  },
  {
    "web-scraper-order": "1666018423-675",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐺 Wolf",
    "name-href": "https://emojipedia.org/wolf/",
    emoji: "🐺",
    emojiName: "🐺 Wolf",
    description:
      "The face of a wolf, a howling canine that hunts in packs. Generally depicted as a cartoon-styled face of a gray wolf with pointed ears, white cheeks and muzzle, and black nose.",
  },
  {
    "web-scraper-order": "1666018427-676",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐩 Poodle",
    "name-href": "https://emojipedia.org/poodle/",
    emoji: "🐩",
    emojiName: "🐩 Poodle",
    description:
      "A poodle, a popular dog breed with curly hair, often groomed in an ornamental pattern.",
  },
  {
    "web-scraper-order": "1666018431-677",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐕‍🦺 Service Dog",
    "name-href": "https://emojipedia.org/service-dog/",
    emoji: "🐕‍🦺",
    emojiName: "🐕‍🦺 Service Dog",
    description:
      "A service animal displayed with a safety vest and lead. Differs from the guide dog as this animal is intended for detection of seizures or other “hidden disabilities”, according to the proposal from Apple.",
  },
  {
    "web-scraper-order": "1666018435-678",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦮 Guide Dog",
    "name-href": "https://emojipedia.org/guide-dog/",
    emoji: "🦮",
    emojiName: "🦮 Guide Dog",
    description:
      "A guide (or Seeing Eye) dog, trained to help lead a person who is blind or visually impaired. Generally depicted as a yellowish-brown Labrador Retriever on all fours facing left, equipped with a harness and handle. Many platforms additionally include a collar.",
  },
  {
    "web-scraper-order": "1666018439-679",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐕 Dog",
    "name-href": "https://emojipedia.org/dog/",
    emoji: "🐕",
    emojiName: "🐕 Dog",
    description:
      "A dog, a faithful, beloved pet canine. Depicted as a light-brown dog, of various breeds, in full profile on all fours facing left, with a long, curled tail held upright and pointed or floppy ears.",
  },
  {
    "web-scraper-order": "1666018447-680",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐶 Dog Face",
    "name-href": "https://emojipedia.org/dog-face/",
    emoji: "🐶",
    emojiName: "🐶 Dog Face",
    description:
      "A friendly, cartoon-styled face of a dog, looking straight ahead. Depicted as the face of a dog of various breeds, generally light-brown and white, with pointed or floppy ears and its tongue hanging out.",
  },
  {
    "web-scraper-order": "1666018452-681",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦧 Orangutan",
    "name-href": "https://emojipedia.org/orangutan/",
    emoji: "🦧",
    emojiName: "🦧 Orangutan",
    description:
      "An orangutan, the orange-haired ape with long arms. Depicted facing forward, with a long broad face and sitting with its legs bent. Occasionally shown scratching its head. Color varies across platforms, ranging from orange to light brown.",
  },
  {
    "web-scraper-order": "1666018457-682",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦍 Gorilla",
    "name-href": "https://emojipedia.org/gorilla/",
    emoji: "🦍",
    emojiName: "🦍 Gorilla",
    description:
      "A gorilla, the powerful, black-haired great ape. Variously depicted in full profile on all fours facing left or as a friendly, cartoon-styled gorilla face looking straight ahead.",
  },
  {
    "web-scraper-order": "1666018462-683",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐒 Monkey",
    "name-href": "https://emojipedia.org/monkey/",
    emoji: "🐒",
    emojiName: "🐒 Monkey",
    description:
      "A monkey, a small primate with long limbs and tail for climbing trees. Generally depicted as a cartoon-styled, brown monkey with a cheeky facial expression, shown in full profile facing left, sitting on its hind legs with a long, curled tail and round ears.",
  },
  {
    "web-scraper-order": "1666018465-684",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐵 Monkey Face",
    "name-href": "https://emojipedia.org/monkey-face/",
    emoji: "🐵",
    emojiName: "🐵 Monkey Face",
    description:
      "A friendly, cartoon-styled face of a monkey, looking straight ahead. Depicted as a brown-haired monkey with a tan or pinkish face, round ears, nostrils, and open-mouthed grin.",
  },
  {
    "web-scraper-order": "1666018468-685",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💨 Dashing Away",
    "name-href": "https://emojipedia.org/dashing-away/",
    emoji: "💨",
    emojiName: "💨 Dashing Away",
    description:
      "A cartoon-styled gust of air. Depicted as a small, gray cloud with motion lines, rushing to the left.",
  },
  {
    "web-scraper-order": "1666018473-686",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💦 Sweat Droplets",
    "name-href": "https://emojipedia.org/sweat-droplets/",
    emoji: "💦",
    emojiName: "💦 Sweat Droplets",
    description:
      "Three, light blue droplets, as sweat beads, splashing down to the right. Resembles plewds, stylized sweat droplets used in comics and animation to show characters working hard or feeling stressed.",
  },
  {
    "web-scraper-order": "1666018477-687",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💫 Dizzy",
    "name-href": "https://emojipedia.org/dizzy/",
    emoji: "💫",
    emojiName: "💫 Dizzy",
    description:
      "A cartoon-styled representation of dizziness. Generally depicted as one or more yellow stars swirling in a yellow or blue circle.",
  },
  {
    "web-scraper-order": "1666018480-688",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💥 Collision",
    "name-href": "https://emojipedia.org/collision/",
    emoji: "💥",
    emojiName: "💥 Collision",
    description:
      "A cartoon-styled representation of a collision. Depicted as a star-like, orange-and-yellow fiery burst, generally with one point extending to the bottom right, as if from the source of the collision.",
  },
  {
    "web-scraper-order": "1666018485-689",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙊 Speak-No-Evil Monkey",
    "name-href": "https://emojipedia.org/speak-no-evil-monkey/",
    emoji: "🙊",
    emojiName: "🙊 Speak-No-Evil Monkey",
    description:
      "The speak no evil monkey, called Iwazaru (Japanese for “say not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its mouth.",
  },
  {
    "web-scraper-order": "1666018490-690",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙉 Hear-No-Evil Monkey",
    "name-href": "https://emojipedia.org/hear-no-evil-monkey/",
    emoji: "🙉",
    emojiName: "🙉 Hear-No-Evil Monkey",
    description:
      "The hear no evil monkey, called Kikazaru (Japanese for “hear not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its ears.",
  },
  {
    "web-scraper-order": "1666018495-691",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙈 See-No-Evil Monkey",
    "name-href": "https://emojipedia.org/see-no-evil-monkey/",
    emoji: "🙈",
    emojiName: "🙈 See-No-Evil Monkey",
    description:
      "The see no evil monkey, called Mizaru (Japanese for “see not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its eyes.",
  },
];
export default animals;
